import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserSettingsService = sdk.getService('UserSettingsService');

export const useUserSettings = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['user-settings'],
    queryFn: () => UserSettingsService.getMyUserSettings()
  });

  return { settings: data, isLoading };
};
